import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import * as Yup from 'yup';
import { getLoginPath } from '../../../../icsc-app/js/helpers/url.helpers';

// Shared
import TextInput from '@atoms/TextInput';
import { ButtonPrimaryLarge, LinkSmall } from '@styled';

// Functionality
import { LoadingContext } from '@context/LoadingProvider';
import { loginMember } from '@general/api/memberAPI';

const LoginPassword = ({ email, onLoginSuccess }) => {
    const { setIsLoading } = useContext(LoadingContext);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async ({ password }, { setFieldError }) => {
        setIsSubmitting(true);
        setIsLoading(true);

        const data = { username: email, password };

        try {
            await loginMember(data);
            if (onLoginSuccess) {
                onLoginSuccess();
            }

            window.location.href = getLoginPath();
        } catch (error) {
            setFieldError('password', error?.response?.data?.error);
            setIsSubmitting(false);
            setIsLoading(false);
        }
    };

    return (
        <div>
            <Formik
                initialValues={{
                    password: '',
                }}
                validateOnBlur
                validateOnChange={false}
                validationSchema={Yup.object().shape({
                    password: Yup.string().required('No password provided'),
                })}
                onSubmit={handleSubmit}
            >
                {() => (
                    <Form>
                        <TextInput name="password" placeholder="Password" type="password" />
                        <div className="flex flex-row align-items-center">
                            <ButtonPrimaryLarge type="submit" disabled={isSubmitting}>
                                Sign In
                            </ButtonPrimaryLarge>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

LoginPassword.propTypes = {
    email: PropTypes.string.isRequired,
    onLoginSuccess: PropTypes.func,
};

export default LoginPassword;
